<div class="generalDiv">
    <div class="mainContentDiv">
      <app-background></app-background> <!-- CIRCULOS DEL FONDO DE LA PAGINA-->
      <div class="divCard">
        <div class="cardContent">
          <form class="formSpace">
            <!-- logo -->
            <div class="logoDiv">
              <img class="imgLogo" src="Logo_Hospify.svg" alt="cognitive_logo">
            </div>
            <!-- nombre -->
            <div>
              <label for="name" class="titleLabels">Nombre(s)</label>
              <input type="text" id="name" name="name" placeholder="Ingresar Nombre(s)" required class="InputClass mt-1" [(ngModel)]="namesModel">
            </div>
  
            <!-- apellidos -->
            <div>
              <label for="lastNames" class="titleLabels">Apellidos</label>
              <input type="text" id="lastNames" name="lastNames" placeholder="Ingresar Apellidos" required class="InputClass mt-1" [(ngModel)]="lastNamesModel">
            </div>
  
            <!-- DNI y Teléfono -->
            <div class="dniTelDiv">
              <div class="flex-1">
                <label for="dni" class="titleLabels">DNI</label>
                <input type="text" id="dni" name="dni" placeholder="Ingresa DNI" required class="InputClass mt-1" [(ngModel)]="dniModel">
              </div>
              <div class="flex-1">
                <label for="phoneNumber" class="titleLabels">Número Telefónico</label>
                <input type="text" id="phoneNumber" name="phoneNumber" placeholder="+52" required class="InputClass mt-1" [(ngModel)]="phoneNumberModel">
              </div>
            </div>
  
            <!-- Email -->
            <div>
              <label for="email" class="titleLabels">Email</label>
              <input type="email" id="email" name="email" placeholder="Ingresar email" required class="InputClass mt-1" [(ngModel)]="emailModel">
            </div>
  
            <!-- Contraseña -->
            <div>
              <label for="password" class="titleLabels">Contraseña</label>
              <input type="password" id="password" name="password" placeholder="Ingresa Contraseña" required class="InputClass mt-1" [(ngModel)]="passwordModel">
            </div>
  
            <!-- Botón -->
              <div class="mt-8">
                <button type="submit" class="continueButton" (click)="showValues()">
                  Confirmar
                </button>
              </div>
          </form>
          <div class="relative mt-5">
            <div class="grayLine" aria-hidden="true">
                <div class="grayLineBorder"></div>
            </div>
          </div>
            <div class="loginButton mt-10">
                <a [routerLink]="['/auth']">Iniciar Sesión</a>
            </div>
        </div>
      </div>
    </div>
  </div>